const URL_PATTERN = /((?:https?:\/\/|www\.)[^\s<]+)/gi;

const normalizeHref = (raw) => {
  if (!raw) return null;
  let href = raw.trim();
  if (!href) return null;
  if (!/^https?:\/\//i.test(href)) {
    href = `https://${href}`;
  }
  try {
    const url = new URL(href);
    url.hash = '';
    return url.toString();
  } catch (err) {
    return href;
  }
};

const shouldSkipNode = (node) => {
  if (!node || !node.parentNode) return true;
  const parent = node.parentNode;
  if (parent.nodeType !== Node.ELEMENT_NODE) return false;
  if (parent.closest('a')) return true;
  if (parent.closest('[data-mention-id]')) return true;
  return false;
};

const linkifyTextNode = (textNode) => {
  const text = textNode.textContent;
  if (!text || !URL_PATTERN.test(text)) {
    URL_PATTERN.lastIndex = 0;
    return;
  }
  URL_PATTERN.lastIndex = 0;
  const doc = textNode.ownerDocument;
  const fragment = doc.createDocumentFragment();
  let lastIndex = 0;
  let match;
  while ((match = URL_PATTERN.exec(text)) !== null) {
    const [rawUrl] = match;
    const start = match.index;
    if (start > lastIndex) {
      fragment.appendChild(doc.createTextNode(text.slice(lastIndex, start)));
    }
    const href = normalizeHref(rawUrl);
    if (href) {
      const anchor = doc.createElement('a');
      anchor.textContent = rawUrl;
      anchor.setAttribute('href', href);
      anchor.setAttribute('target', '_blank');
      anchor.setAttribute('rel', 'noopener noreferrer nofollow');
      anchor.classList.add('auto-linked-url', 'spark-auto-link');
      fragment.appendChild(anchor);
    } else {
      fragment.appendChild(doc.createTextNode(rawUrl));
    }
    lastIndex = start + rawUrl.length;
  }
  if (lastIndex < text.length) {
    fragment.appendChild(doc.createTextNode(text.slice(lastIndex)));
  }
  textNode.replaceWith(fragment);
};

export const linkifyElement = (element) => {
  if (typeof window === 'undefined' || !element) return;
  const walker = element.ownerDocument.createTreeWalker(
    element,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        if (!node || !node.textContent || !node.textContent.includes('http')) {
          const trimmed = node?.textContent?.trim();
          if (!trimmed || !/(https?:\/\/|www\.)/.test(trimmed)) return NodeFilter.FILTER_REJECT;
        }
        return shouldSkipNode(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      },
    },
  );

  const nodes = [];
  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }

  nodes.forEach(linkifyTextNode);
};

export default linkifyElement;
